import { memo } from "react";
import { Icon, DivLogoBox } from "./style";
import { NextLink } from "~/components/blocks/common/next-link";
import { PATHS } from "~/const/paths";

/**
 * ヘッダーに表示するロゴ
 */

type LogoProps = {
  isShowDmmService?: boolean;
  onCloseDmmService?: () => void;
};

export const Logo = memo(({ isShowDmmService, onCloseDmmService }: LogoProps) => {
  return (
    <DivLogoBox>
      <NextLink href={PATHS.VOD} onClick={onCloseDmmService && isShowDmmService ? onCloseDmmService : undefined}>
        <Icon name="dmmTv" ariaLabel="DMM TV" />
      </NextLink>
    </DivLogoBox>
  );
});

Logo.displayName = "Logo";
